export enum ConsumerLoanLogMessageEngagementStatus {
    Open,
    Click,
    SpamReport
}